import * as Sentry from '@sentry/react';

const dsn =
  import.meta.env.VITE_GLITCHTIP_DSN ||
  'https://27dc9efffe9d4508b51e6237200e7cab@bsr-log.boonsiri.co.th/10';

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.01,
    autoSessionTracking: false,
  });
}

export { Sentry };
